export const SB_PAY_LABEL = '報酬分広告費';

export const SB_DATA_INDEXES = {
  SCOUT_ID: 0,
  REWARD: 1,
  ACTIVE_RESV_COUNT: 2,
  SB_PAY_INDEX: 3,
  CON_PAY_INDEX: 4,
  SHOP_SB_LIST_INDEX: 5,
};